<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue-datepicker-next';

export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: [],
    },
  },
  emits: ['change'],
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    document.addEventListener('mousedown', this.handleDocumentClick, true);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, true);
  },

  computed: {
    resolvedConfirmText() {
      if (this.confirmText != null && String(this.confirmText).trim() !== '') {
        return this.confirmText;
      }
      return 'OK';
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('change', value);
      this.isOpen = false;
    },
    handleOpenChange(value) {
      this.isOpen = value;
    },
    handleDocumentClick(event) {
      if (!this.isOpen) return;

      const clickedInsideRoot = this.$el?.contains(event.target);
      const clickedInsidePopup = event.target?.closest?.('.mx-datepicker-popup');

      if (!clickedInsideRoot && !clickedInsidePopup) {
        this.isOpen = false;
      }
    },
    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), -1);
      return date < yesterdayDate;
    },
  },
};
</script>

<template>
  <div class="date-picker">
    <DatePicker
      type="datetime"
      confirm
      :clearable="false"
      :editable="false"
      :confirm-text="resolvedConfirmText"
      :placeholder="placeholder"
      :value="value"
      :open="isOpen"
      :disabled-date="disableBeforeToday"
      @update:open="handleOpenChange"
      @change="handleChange"
    />
  </div>
</template>
